import React from 'react';
import { Form } from 'react-bootstrap';

const ErrorMsg = ({ msg = '', callback = null }) => {
  const innerCallback = () => {
    if (callback) callback();
  };
  return (
    <Form.Control.Feedback
      onClick={innerCallback}
      style={{
        display: `${msg ? 'block' : 'none'}`,
        cursor: `${callback ? 'pointer' : 'initial'}`,
      }}
      type="invalid">
      {msg}
    </Form.Control.Feedback>
  );
};

export default ErrorMsg;
